<style lang="less" scoped>
  @import "../../vars.less";
  .title {
    margin: 0;
    padding: 12px;
    font-size: 12px;
    font-weight: 500;
    color: @text-color;
  }
  .shortcuts {
    padding-bottom: 8px;
    background-color: #fff;
    margin-bottom: @space-normal;
  }
  .shortcut-core {
    text-align: center;
    font-size: 12px;
    color: @text-color;
    width: 100%;
    height: 100%;
    img {
      width: 36px;
      height: 36px;
    }
    p {
      margin: @space-small 0;
    }
  }
  .shortcut {
    &.disabled img {
      filter: grayscale(100%);
    }
  }
  .icon {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 16px;
    color: @text-color-secondary;
  }
  .btn-container {
    padding: @space-normal;
    & > *:not(:last-child) {
      margin-bottom: @space-normal;
    }
  }
</style>

<template>
  <page-container class="set-shortcuts"
    :title="$t('功能配置')"
    :loading="!!loading">
    <div class="shortcuts">
      <h4 class="title">{{ $t('首页功能') }}</h4>
      <van-grid
        :border="true" clickable :gutter="8"
        icon-size="36px">
        <van-grid-item class="shortcut"
          v-for="item of shortcuts" :key="item.code"
          :class="{ disabled: !$auth(item.code) }"
          @click="() => remove(item)">
          <div class="shortcut-core">
            <img :src="`/images/shortcut-icons/${item.icon}`" />
            <p>{{ item.name }}</p>
            <van-icon name="clear" class="icon remove-icon" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="shortcuts" v-show="restShortcuts.length">
      <h4 class="title">{{ $t('全部功能') }}</h4>
      <van-grid class="shortcuts-page van-hairline--left"
        :border="true" :gutter="8"
        clickable
        icon-size="36px">
        <van-grid-item class="shortcut"
          v-for="item of restShortcuts" :key="item.code"
          :class="{ disabled: !$auth(item.code) }"
          @click="() => add(item)">
          <div class="shortcut-core">
            <img :src="`/images/shortcut-icons/${item.icon}`" />
            <p>{{ item.name }}</p>
            <van-icon name="add" class="icon remove-icon" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="btn-container" slot="footer">
      <van-button block type="info" size="small" round @click="confirm">{{$t('确定')}}</van-button>
      <van-button block type="info" size="small" round plain @click="cancel">{{$t('取消')}}</van-button>
    </div>
  </page-container>
</template>

<script>
import { Grid, GridItem, Icon, Toast, Button, Notify } from 'vant'
import PageContainer from '../../components/PageContainer'
import originShortcuts from './shortcuts'
import { HOME_SHORTCUTS_COUNT } from '../../constants'

export default {
  name: 'set-shortcuts',
  components: {
    PageContainer,
    'van-grid': Grid,
    'van-grid-item': GridItem,
    'van-icon': Icon,
    'van-button': Button
  },
  data () {
    return {
      loading: 0,
      originShortcuts,
      allShortcuts: [],
      savedShortcuts: []
    }
  },
  computed: {
    shortcuts () {
      return this.savedShortcuts.map(it => {
        const os = this.originShortcuts.find(sc => sc.code === it.op_code)
        return {
          ...os,
          name: it.op_name,
          code: it.op_code
        }
      })
    },
    restShortcuts () {
      return this.originShortcuts
        .filter(sc => this.savedShortcuts.findIndex(it => it.op_code === sc.code) === -1)
        .map(it => {
          const s = this.allShortcuts.find(a => a.op_code === it.code)
          if (!s) return null
          console.log(s.op_code, s.op_name)
          return {
            ...it,
            name: s.op_name,
            code: s.op_code
          }
        }).filter(Boolean)
    }
  },
  methods: {
    getAllShortcuts () {
      this.$apis.home
        .getAllShortcuts(lo => lo ? this.loading++ : this.loading--)
        .then(res => {
          if (res) this.allShortcuts = res
        })
    },
    getAvaliableShortCuts () {
      this.$apis.home
        .getAvaliableShortCuts(lo => lo ? this.loading++ : this.loading--)
        .then(res => {
          if (res) this.savedShortcuts = res
        })
    },
    add (item) {
      this.savedShortcuts.push({ op_code: item.code, op_name: item.name })
    },
    remove (item) {
      if (this.savedShortcuts.length === HOME_SHORTCUTS_COUNT) {
        Toast(this.$t('首页功能不能少于个', { limit: HOME_SHORTCUTS_COUNT }))
      } else {
        const index = this.savedShortcuts.findIndex(it => it.op_code === item.code)
        this.savedShortcuts.splice(index, 1)
      }
    },
    confirm () {
      this.$apis.home.setAvaliableShortcuts(
        this.savedShortcuts,
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          Notify({
            type: 'success',
            message: this.$t('设置成功')
          })
          this.$back()
        }
      })
    },
    cancel () {
      this.$back()
    }
  },
  mounted () {
    this.getAllShortcuts()
    this.getAvaliableShortCuts()
  }
}
</script>
